import React, { useState } from 'react';
import { Clock, Percent, Sparkles, ArrowRight, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import BookingCalendar from './BookingCalendar';

const SHARE_MSG = `Thursday Deal at Dublin Holistic Massage! Extra 5% off massages booked on Thursdays 9am-6pm with Buggie, Eegi, or Lana. Stack it with the 5% online deposit discount for 10% off!\n\nBook here: https://www.dublinholisticmassages.com`;

const ThursdayDeal = () => {
  const [bookingOpen, setBookingOpen] = useState(false);

  return (
    <>
      <section className="py-14 bg-luxury-green relative overflow-hidden" data-testid="thursday-deal">
        <div className="absolute inset-0 opacity-10" style={{backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M30 0L60 30L30 60L0 30Z\' fill=\'none\' stroke=\'%23D4AF37\' stroke-width=\'0.5\'/%3E%3C/svg%3E")'}} />

        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 bg-luxury-gold/20 text-luxury-gold px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider mb-5">
                <Sparkles size={14} />
                Thursday Special
              </div>

              <h2 className="font-display text-3xl sm:text-4xl text-white mb-3 leading-tight">
                Thursday Deal
                <span className="block text-luxury-gold italic mt-1">Extra 5% Off</span>
              </h2>

              <p className="text-white/70 font-light max-w-lg mb-6 leading-relaxed">
                Book any massage on <strong className="text-white">Thursday between 9am and 6pm</strong> with
                <strong className="text-luxury-gold"> Buggie, Eegi, or Lana</strong> and enjoy an extra 5% off
                — on top of the 5% you already save with an online deposit!
              </p>

              <div className="flex flex-wrap gap-3 mb-6">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl px-4 py-2.5 flex items-center gap-2">
                  <Clock size={16} className="text-luxury-gold" />
                  <span className="text-white text-sm font-medium">Thursdays, 9am - 6pm</span>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl px-4 py-2.5 flex items-center gap-2">
                  <Percent size={16} className="text-luxury-gold" />
                  <span className="text-white text-sm font-medium">Extra 5% off</span>
                </div>
              </div>

              <div className="flex gap-3 mb-4">
                {['Buggie', 'Eegi', 'Lana'].map(name => (
                  <div key={name} className="bg-luxury-gold/15 border border-luxury-gold/30 rounded-full px-4 py-1.5">
                    <span className="text-luxury-gold text-sm font-medium">{name}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="bg-luxury-gold/10 border border-luxury-gold/30 rounded-3xl p-8 text-center backdrop-blur-sm">
                <div className="text-luxury-gold text-6xl font-display font-bold mb-1">10%</div>
                <div className="text-white/70 text-sm mb-1">Total savings when combined</div>
                <div className="text-luxury-gold/80 text-xs">5% deposit + 5% Thursday deal</div>

                <Button
                  onClick={() => setBookingOpen(true)}
                  className="mt-6 bg-luxury-gold hover:bg-luxury-gold/90 text-luxury-green rounded-full px-8 py-5 text-xs uppercase tracking-wider font-semibold group"
                  data-testid="thursday-deal-book-btn"
                >
                  Book Thursday
                  <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
                <Button
                  onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(SHARE_MSG)}`, '_blank')}
                  className="mt-3 bg-luxury-green-600 hover:bg-luxury-green-500 text-white rounded-full w-full py-4 text-xs uppercase tracking-wider font-medium"
                  data-testid="thursday-deal-whatsapp-share"
                >
                  <MessageCircle size={16} className="mr-2" />
                  Share on WhatsApp
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookingCalendar isOpen={bookingOpen} onClose={() => setBookingOpen(false)} />
    </>
  );
};

export default ThursdayDeal;
